import { SanitizedText } from '@/ui/SanitizedDom';
import { useHistory } from 'react-router-dom';

export const HtmlText = ({ html }) => {
  const history = useHistory();

  const onClickHtml = (e) => {
    const targetLink = e.target.closest('a');
    if (!targetLink) return;
    const hrefURL = new URL(targetLink?.href);
    const pageURL = new URL(window.location);
    if (!targetLink || hrefURL.host !== pageURL.host) return;
    const { pathname } = new URL(targetLink.href);
    history.push(pathname);
    e.preventDefault();
  };

  const linkColor = '#503BF0';
  // note: BE is sending the html code, a tag as string, sanitized to allow only our domains for now
  const sanitizedString = html?.replace(
    /<A\s+HREF="([^"]*)">([^<]+)<\/A>/gi,
    (match, href, content) => {
      // Check if href is not empty and not null
      if (href && href !== '/') {
        // Remove the domain part from the URL
        const path = href.replace(/^(?:\/\/|[^/]+)*\//, '/');

        // Return the content with the replaced href attribute
        return path === '/'
          ? content
          : `<A HREF="${path}" style="color: ${linkColor};">${content}</A>`;
      } else {
        // If href is empty, null, or doesn't contain any path, remove the entire <A> tag
        return content;
      }
    }
  );

  return (
    <SanitizedText
      as="span"
      color="secondary-900"
      onClick={onClickHtml}
      html={sanitizedString}
    />
  );
};
